var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"material-icons sm",style:({
    fontSize: '8px',
    color: _vm.color,
  })},[_vm._v("\n  lens\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }